// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".j1an1MisnviLUj1HGlNg{position:absolute;top:4px;pointer-events:none;z-index:3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brandBarPosition": "j1an1MisnviLUj1HGlNg"
};
export default ___CSS_LOADER_EXPORT___;
